import { useState } from "react";
import { getImageUrl, getInitials } from "../lib/avatarUtils";

/**
 * Reusable Avatar component with photo + initials fallback.
 * Handles broken image URLs gracefully by showing initials.
 */
export function Avatar({ src, name, size = "md", className = "", testId }) {
  const [imgFailed, setImgFailed] = useState(false);

  const sizeMap = {
    xs: "w-6 h-6 text-[9px]",
    sm: "w-8 h-8 text-xs",
    md: "w-10 h-10 text-sm",
    lg: "w-16 h-16 text-xl",
    xl: "w-28 h-28 text-3xl",
  };

  const sizeClass = sizeMap[size] || sizeMap.md;
  const resolvedUrl = src ? getImageUrl(src) : null;
  const showImg = resolvedUrl && !imgFailed;

  return (
    <div
      className={`rounded-full bg-[#00BFFF]/10 flex items-center justify-center overflow-hidden shrink-0 ${sizeClass} ${className}`}
      data-testid={testId}
    >
      {showImg ? (
        <img
          src={resolvedUrl}
          alt={name || "Avatar"}
          className="w-full h-full rounded-full object-cover"
          onError={() => setImgFailed(true)}
          loading="lazy"
        />
      ) : (
        <span className="font-heading font-bold text-[#00BFFF]">
          {getInitials(name)}
        </span>
      )}
    </div>
  );
}
